import React, { useState } from "react";
import { BiMenu, BiChevronLeft } from "react-icons/bi";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaUser,
  FaBell,
  FaFileAlt,
  FaShoppingCart,
  FaUserCircle,
  FaSignInAlt,
  FaEnvelope,
  FaCog,
  FaChartBar,
  FaPlug,
  FaPuzzlePiece,
  FaClipboardList,
  FaCogs,
  FaStream,
  FaTasks,
  FaLayerGroup,
  FaUsers,
  FaBookOpen,
  FaSignOutAlt,
} from "react-icons/fa";
import { AlarmCheck, Bot } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import mini_logo from "../../images/logo-mini.png";
import logo from "../../images/logo-min-white.png";
import "../css/Sidebar.css";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();

  const tenantName = localStorage.getItem("tenantName");

  const handleNavClick = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    // Clear localStorage items
    // localStorage.removeItem("tenantName");
    // localStorage.removeItem("tenantEmail");

    // You might want to clear other items as well
    localStorage.clear(); // Uncomment this if you want to clear everything

    // Redirect to login page or home page
    // navigate("/login");
    window.location.href = `${process.env.REACT_APP_SITE_URL}/login`; // Redirect to home or login page
    setShowLogoutConfirm(false);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <div className="app-container">
      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="logout-modal-overlay">
          <div className="logout-modal-content">
            <div className="logout-modal-header">
              <h5 className="logout-modal-title">Confirm Logout</h5>
            </div>
            <div className="logout-modal-body">
              <p>Are you sure you want to logout?</p>
            </div>
            <div className="logout-modal-footer">
              <button className="btn btn-secondary" onClick={cancelLogout}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={confirmLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <div className={`sidebar bg-light ${isCollapsed ? "collapsed" : ""}`}>
        {/* Logo Area with fixed 64px height */}
        <div className="sidebar-logo-container">
          {isCollapsed ? (
            <img src={mini_logo} alt="logo" className="sidebar-mini-logo" />
          ) : (
            <img src={logo} alt="logo" className="sidebar-full-logo" />
          )}
        </div>

        {/* Navigation Items Container */}
        <div className="sidebar-nav-container">
          {/* Navigation Items */}
          <NavLink
            to={`/${tenantName}/dashboard`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/dashboard`)}
          >
            <FaHome className="nav-icon" /> <span>Home</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/campaigns`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/campaigns`)}
          >
            <AlarmCheck className="nav-icon" /> <span>Campaigns</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/template-Library`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/template-Library`)}
          >
            <FaBookOpen className="nav-icon" /> <span>Template Library</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/templateForm`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/templateForm`)}
          >
            <FaClipboardList className="nav-icon" /> <span>Template Form</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/templateList`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/templateList`)}
          >
            <FaFileAlt className="nav-icon" /> <span>Template List</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/Bot-Workflow-manage`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/Bot-Workflow-manage`)}
          >
            <Bot className="nav-icon" /> <span>Bot Workflow</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/users`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/users`)}
          >
            <FaUsers className="nav-icon" /> <span>Users</span>
          </NavLink>

          <NavLink
            to={`/${tenantName}/contacts/segment`}
            className="nav-link"
            onClick={() => handleNavClick(`/${tenantName}/contacts/segment`)}
          >
            <FaUsers className="nav-icon" /> <span>Segment</span>
          </NavLink>

          {/* Logout Button - Added at the bottom */}
          <div className="nav-divider"></div>

          <button className="nav-link logout-btn" onClick={handleLogout}>
            <FaSignOutAlt className="nav-icon" /> <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Toggle Button OUTSIDE the sidebar */}
      <button
        className={`toggle-btn-outside ${isCollapsed ? "collapsed" : ""}`}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        {isCollapsed ? <BiMenu size={20} /> : <BiChevronLeft size={20} />}
      </button>
    </div>
  );
};

export default Sidebar;
